import React, { useCallback, useMemo, useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'

import { NavGroup } from '~shared/models/NavigationModels'
import DrawerComponent from './components/DrawerComponent/DrawerComponent'
import AppBarComponent from './components/AppBarComponent/AppBarComponent'
import DrawerHeaderOverlay from './components/DrawerHeaderOverlay/DrawerHeaderOverlay'
import { useAppBarComponentStyles } from './components/AppBarComponent/AppBarComponentStyles'
import { useNavigationContainerStyles } from './NavigationContainerStyles'

interface Props {
  navGroups: NavGroup[]
}

export interface DrawerStatusProps {
  isMobile: boolean
  drawerLarge: boolean
  drawerOpen: boolean
  useHoverDrawer: boolean
}

export interface DrawerHandlingProps {
  toggleDrawerLarge: () => void
  toggleDrawerOpen: () => void
  toggleUseHoverDrawer: () => void
}

export type DrawerProps = DrawerStatusProps & DrawerHandlingProps;

const NavigationContainer: React.FC<Props> = (props) => {
  const s = useNavigationContainerStyles()
  const stylesAppBar = useAppBarComponentStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'))

  // todo - create options page to let the user preset these options
  const [useHoverDrawer, setuseHoverDrawer] = useState<boolean>(false)
  const toggleUseHoverDrawer = useCallback(() => setuseHoverDrawer(!useHoverDrawer), [useHoverDrawer, setuseHoverDrawer])

  const [drawerLarge, setDrawerLarge] = useState<boolean>(true)
  const toggleDrawerLarge = useCallback(() => setDrawerLarge(!drawerLarge), [drawerLarge, setDrawerLarge])

  const [drawerOpen, setDrawerOpen] = useState<boolean>(false)
  const toggleDrawerOpen = useCallback(() => setDrawerOpen(!drawerOpen), [drawerOpen, setDrawerOpen])

  const drawerStatus: DrawerProps = useMemo(() => {
    return {
      useHoverDrawer: isTablet || useHoverDrawer,
      toggleUseHoverDrawer: toggleUseHoverDrawer,
      drawerLarge: isTablet || drawerLarge,
      toggleDrawerLarge: toggleDrawerLarge,
      drawerOpen: drawerOpen,
      toggleDrawerOpen: toggleDrawerOpen,
      isMobile: isMobile,
    }
  }, [drawerLarge, drawerOpen, isMobile, isTablet, toggleDrawerLarge, toggleDrawerOpen, toggleUseHoverDrawer, useHoverDrawer])

  return <div className={s.root}>
    <AppBarComponent {...drawerStatus} />
    <DrawerComponent navGroups={props.navGroups} {...drawerStatus} />
    <main
      className={s.contentContainer}
      style={isMobile ? {} : { height: '100vh', maxHeight: '100vh' }}   // fix for safari
    >
      <div className={stylesAppBar.appBarSpacer} />
      <div className={s.content}>
        {props.children}
      </div>
    </main>
  </div>
}

export default NavigationContainer
